import styled from "styled-components";

export const Box = styled.div`
    background-color: #eec1c1;
    color: #21384F;
    display: flex;
    padding: 30px;
    justify-content: space-between;
    border-radius: 7px;
    margin-bottom: 30px;
    p {
        cursor: pointer;
    }
`

export const Remove = styled.img`
    height: 30px;
    cursor: pointer;
`